// Global DOM components.
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Router } from 'react-router-dom'

// The App.
import App from './components/App'
import history from 'utils/history'

// React Query.
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Redux.
import { Provider } from 'react-redux'
import store from './store'

// Localization
import './i18n'

// Global CSS.
import './tailwind.css'
import './index.css'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </QueryClientProvider>
)
